/**
 * @Author: Ygm
 * @Date: 2025-07-28 11:11:57
 * @LastEditors: Ygm
 * @LastEditTime: 2025-07-29 08:56:45
 * @Description:
 */
const defaultRouters = [
  {
    name: 'DataProcessingList',
    path: '/dataProcessing/list',
    title: '内容截图',
    component: () => import('@/view/pages/DataProcessing/list.vue')
  }
]

export default defaultRouters



// WEBPACK FOOTER //
// ./src/router/dataProcessing.js